import { useRef, useState } from "react";
import { FileDownload } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import {
  ExportExcel,
  Toolbar,
  type GridExcelExportOptions,
} from "@mui/x-data-grid-premium";

interface AnalysisResultsToolbarProps {
  excelOptions?: GridExcelExportOptions;
}

const AnalysisResultsToolbar: React.FC<AnalysisResultsToolbarProps> = ({
  excelOptions,
}) => {
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const exportMenuTriggerRef = useRef<HTMLButtonElement>(null);

  const handleCloseExportMenu = () => {
    setExportMenuOpen(false);
  };

  const handleOpenExportMenu = () => {
    setExportMenuOpen(true);
  };

  return (
    <Toolbar>
      <Button
        ref={exportMenuTriggerRef}
        aria-controls={
          exportMenuOpen ? "analysis-results-export-menu" : undefined
        }
        aria-expanded={exportMenuOpen ? "true" : undefined}
        aria-haspopup="true"
        aria-label="Download"
        id="analysis-results-export-menu-trigger"
        onClick={handleOpenExportMenu}
        size="small"
        startIcon={<FileDownload />}
      >
        Download
      </Button>
      <Menu
        anchorEl={exportMenuTriggerRef.current}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        id="analysis-results-export-menu"
        onClose={handleCloseExportMenu}
        open={exportMenuOpen}
        slotProps={{
          list: {
            "aria-labelledby": "analysis-results-export-menu-trigger",
          },
        }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
      >
        <ExportExcel
          onClick={handleCloseExportMenu}
          options={excelOptions}
          render={<MenuItem />}
        >
          Download as Excel
        </ExportExcel>
      </Menu>
    </Toolbar>
  );
};

export default AnalysisResultsToolbar;
